import { SearchUserType } from '@app/modules/user/schema/user.enum';
import { DefaultConstants } from '@app/typings/default';

const Default: DefaultConstants = {
  isOpenDropdown: true,
  formatDateTime: 'MMM D, YYYY h:mm:ss A',
  briefLists: {
    offset: 0,
    limit: 0,
    brief: true,
  },
  tempAlert: {
    level1: 50,
    level2: 70,
  },
  pages: {
    offset: 0,
    limit: 0,
  },
  manageTable: {
    projectEndUser: {
      email: true,
      firstName: true,
      lastName: true,
      no: true,
      phone: true,
      role: true,
      status: true,
      type: true,
    },
    winnonieService: {
      stationNo: true,
      station: true,
      type: true,
      address: true,
      district: false,
      province: false,
      location: false,
      flood: false,
      gas: false,
      temp: false,
      meter: true,
      status: true,
      activation: true,
      breaker: true,
      setting: true,
      total: true,
      locker: {
        empty: true,
        charging: true,
        charged: true,
        reserved: true,
        failed: true,
        inactive: true,
        pending: true,
      },
      niuCharger: {
        DISABLED: false,
        ERROR: false,
        ERR_FLAG: false,
        ERR_NORM_TO: false,
        ERR_RS485_FAULT: false,
        ERR_SLOW_TO: false,
        ERR_UNB: false,
        FAST_RECOVERY: false,
        FULL: false,
        IDLE: false,
        NORMAL_CHARGE: false,
        NO_POWER: false,
        SLOW_RECOVERY: false,
        SOFT_FULL: false,
        UNKNOWN: false,
        WARNING: false,
        WARN_FLAG: false,
        WARN_UNB: false,
      },
      universalCharger: {
        CHARGE_1: false,
        CHARGE_2: false,
        DISABLE: false,
        DOOR_CLOSE: false,
        DOOR_OPEN: false,
        ERR_BAT_FAULT: false,
        ERR_BAT_RS485_FAULT: false,
        ERR_CHG_FAULT: false,
        ERR_CHG_TIMEOUT: false,
        ERR_PCHG_TIMEOUT: false,
        ERR_RCHG_TIMEOUT: false,
        ERR_TEMP_TIMEOUT: false,
        FULL: false,
        NO_CHARGER: false,
        PRE_CHARGE: false,
        RECHARGE: false,
        R_MEAS: false,
        SOFT_FULL: false,
        UNKNOWN: false,
        WAIT_TEMP_BAT: false,
        WAIT_TEMP_CHG: false,
      },
    },
  },
  filter: {
    projectEndUser: {
      searchType: SearchUserType.EMAIL,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      status: '',
      roleName: '',
    },
    winnonie: {
      batteries: {
        from: undefined,
        to: undefined,
        statuses: [],
        serialNumber: '',
        station: '',
      },
      batteryLogs: {
        from: undefined,
        to: undefined,
        statuses: [],
        serialNumber: '',
        stations: [],
      },
      evLockersBrandLevel: {
        projectIds: [],
        statuses: [],
        serialNumber: '',
        lockerNumber: Number(''),
      },
      evLockersProjectLevel: {
        statuses: [],
        serialNumber: '',
        lockerNumber: Number(''),
      },
      evLockerLogsBrandLevel: {
        from: undefined,
        to: undefined,
        projectIds: [],
        statuses: [],
        actions: [],
        serialNumber: '',
        lockerNumber: Number(''),
      },
      evLockerLogsProjectLevel: {
        statuses: [],
        actions: [],
        serialNumber: '',
        lockerNumber: Number(''),
      },
      rider: {
        projectIds: [],
        stationName: '',
        evLockerStatuses: [],
        lockerNumber: Number(''),
        from: undefined,
        to: undefined,
      },
      stations: {
        statuses: [],
        provinces: [],
        stationNo: Number(''),
        projectIds: [],
        onlineStatus: undefined,
        types: [],
      },
      transactionsBrandLevel: {
        projectIds: [],
        stationName: '',
        evLockerStatuses: [],
        lockerNumber: Number(''),
        from: undefined,
        to: undefined,
      },
      transactionsProjectLevel: {
        stationName: '',
        evLockerStatuses: [],
        lockerNumber: Number(''),
        from: undefined,
        to: undefined,
      },
      users: {
        statuses: [],
        licensePlate: '',
        name: '',
        phone: '',
      },
      stationLogsBrandLevel: {
        from: undefined,
        to: undefined,
        action: undefined,
        projectIds: [],
      },
      stationLogsProjectLevel: { from: undefined, to: undefined, action: undefined },
    },
  },
  EZUIKitThemeData: {
    autoFocus: 5,
    poster: 'https://resource.eziot.com/group1/M00/00/89/CtwQEmLl8r-AZU7wAAETKlvgerU237.png',
    header: {
      color: '#1890ff',
      activeColor: '#FFFFFF',
      backgroundColor: '#000000',
      btnList: [
        {
          iconId: 'deviceID',
          part: 'left',
          defaultActive: 0,
          memo: 'device ID',
          isrender: 1,
        },
        {
          iconId: 'deviceName',
          part: 'left',
          defaultActive: 0,
          memo: 'Device name',
          isrender: 1,
        },
      ],
    },
    footer: {
      color: '#FFFFFF',
      activeColor: '#1890FF',
      backgroundColor: '#00000021',
      btnList: [
        {
          iconId: 'play',
          part: 'left',
          defaultActive: 1,
          memo: 'play',
          isrender: 1,
        },
        {
          iconId: 'capturePicture',
          part: 'left',
          defaultActive: 0,
          memo: 'capture picture',
          isrender: 1,
        },
        {
          iconId: 'sound',
          part: 'left',
          defaultActive: 0,
          memo: 'sound',
          isrender: 1,
        },
        {
          iconId: 'talk',
          part: 'left',
          defaultActive: 0,
          memo: 'talk',
          isrender: 1,
        },
        {
          iconId: 'zoom',
          part: 'left',
          defaultActive: 0,
          memo: 'zoom',
          isrender: 1,
        },
        {
          iconId: 'webExpend',
          part: 'right',
          defaultActive: 0,
          memo: 'expend',
          isrender: 1,
        },
        {
          iconId: 'expend',
          part: 'right',
          defaultActive: 0,
          memo: 'expend',
          isrender: 1,
        },
      ],
    },
  },
};

export default Default;
